document.addEventListener("redirect-to", (evt) => {
  window.location.href = evt.detail.value
})
